
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as cx from 'classnames';



// component
const Component: React.FunctionComponent<any> = (props: InterfaceRealTimes<any>): JSX.Element =>{

    const { items, onOpenModal } = props;
    
    
    return(
        
        <li className={cx("items-cart",{"highlight":Number(Math.ceil(items.prod.pred_classif)) === 5})}>
            <div className="items-cart-insider">
                <div className="image-cart">
                    <div className="notes-class">{items && items.prod && items.prod.pred_classif}</div>
                    <img src={items && items.prod && items.prod.image_url} alt=""  onClick={onOpenModal}/>
                </div>
                <div className="image-cart-info">
                    <span className="class-detection">Class : {items && items.prod && Math.ceil(items.prod.pred_classif)}</span>
                    <span className="times-detection">
                        <span className="icons-timer">
                            <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 1.14258V0H0V1.14258C0 1.64023 0.320513 2.06172 0.769231 2.21914V10.7809C0.320513 10.9383 0 11.3598 0 11.8574V13H10V11.8574C10 11.3598 9.67949 10.9383 9.23077 10.7809V2.21914C9.67949 2.06172 10 1.64023 10 1.14258ZM7.69231 10.7148V9.24727C7.69231 8.35352 7.24359 7.52578 6.49231 7.02812L5.69231 6.5L6.49231 5.97187C7.24359 5.47676 7.69231 4.64648 7.69231 3.75273V2.28516H8.46154V10.7148H7.69231ZM2.30769 2.28516V3.75273C2.30769 4.64648 2.75641 5.47422 3.50769 5.97187L4.30769 6.5L3.50769 7.02812C2.75641 7.52324 2.30769 8.35352 2.30769 9.24727V10.7148H1.53846V2.28516H2.30769ZM3.07692 2.28516H6.92308V3.75273C6.92308 4.39004 6.60256 4.98418 6.06667 5.33711L5 6.04297L3.93333 5.33965C3.39744 4.98418 3.07692 4.39258 3.07692 3.75273V2.28516ZM5 6.95703L6.06667 7.66035C6.35385 7.85078 6.57692 8.10723 6.72564 8.40176H3.27436C3.42051 8.10469 3.64615 7.84824 3.93333 7.66035L5 6.95703ZM3.07692 9.24727C3.07692 9.21934 3.07692 9.19394 3.07949 9.16602H6.92308C6.92308 9.19394 6.92564 9.21934 6.92564 9.24727V10.7148H3.07692V9.24727ZM0.769231 0.761719H9.23077V1.14258C9.23077 1.35332 9.05897 1.52344 8.84615 1.52344H1.15385C0.941026 1.52344 0.769231 1.35332 0.769231 1.14258V0.761719ZM9.23077 12.2383H0.769231V11.8574C0.769231 11.6467 0.941026 11.4766 1.15385 11.4766H8.84615C9.05897 11.4766 9.23077 11.6467 9.23077 11.8574V12.2383Z" fill="#4DA1FF"/>
                            </svg>
                        </span>
                        <span>{items && items.prod && items.prod.pred_time} ms</span>
                    </span>
                </div>
            </div>
        </li>
    )
}

// interface 
export interface InterfaceRealTimes<T>{
    items?:T,
    onOpenModal?:T
    index?:number
}

/**
 * DefaultProps values
 */
Component.defaultProps= {

}

export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/realtimes/component.tsx